import ACTIONS from "./actions";

const initialState = {
  isLoading: false,
  isError: false,
  data: null,
};

function chargerConfigReducer(state, action) {
  switch (action.type) {
    case ACTIONS.FETCH_CHARGER_CONFIG_INIT:
      return {
        ...state,
        isLoading: true,
        isError: false,
      };
    case ACTIONS.FETCH_CHARGER_CONFIG_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isError: false,
        data: action.payload,
      };
    case ACTIONS.FETCH_CHARGER_CONFIG_FAILURE:
      return {
        ...state,
        isLoading: false,
        isError: true,
      };
    default:
      return state;
  }
}

export { initialState };
export default chargerConfigReducer;
